import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { PointsTransferData } from './pointsTransfer.types';
const getPointsTransfer = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<PointsTransferData[]>>('/pointsTransfer')).data;
};

export const pointsTransferQueries = {
  all: () => ['pointsTransfer'],

  list: () =>
    queryFactoryOptions<ApiResponse<PointsTransferData[]>>({
      queryKey: [...pointsTransferQueries.all(), 'list'],
      queryFn: (client) => getPointsTransfer(client),
    }),
};
